import { OperationMS } from '../../types';

// Roles acheteur pour l'onglet Marché. On REPRODUIT la logique legacy (role.toLowerCase +
// includes) telle quelle : changer le "qui peut signer" serait un changement de comportement
// a risque. Centralise ici pour une source unique.
export const isAcheteurSimple = (role?: string): boolean => {
  const r = (role || '').toLowerCase();
  return r === 'acheteur' && !r.includes('signataire');
};

export const isAcheteurSignataire = (role?: string): boolean => {
  const r = (role || '').toLowerCase();
  return (
    r.includes('acheteur signataire') ||
    r.includes('responsable_achat') ||
    r.includes('validateur')
  );
};

// Bloc statut 7 (mode automatique) : l'utilisateur courant est-il LE signataire acheteur
// designe sur l'operation ? Gate par identite (id_user), pas par chaine de role.
export const isDesignatedAcheteurSignataire = (
  operation: OperationMS,
  userId?: number | string,
): boolean =>
  userId !== undefined &&
  operation.acheteur_signataire?.id_user !== undefined &&
  String(operation.acheteur_signataire.id_user) === String(userId);
